import React from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@src/componentsNew/Icons/Icons/ArrowBackIcon';
interface IProps {
  style?: any;
  onClick?: () => void;
}

const BackButton = ({ style, onClick }: IProps) => {
  return (
    <IconButton onClick={onClick} style={{ padding: 0, ...style }}>
      <ArrowBackIcon />
    </IconButton>
  );
};

export default BackButton;
